import { ApolloError } from "@apollo/client";

import { AuthenticationStatus } from "./context";
import { CurrentUserQuery } from "../../graphql/graphql";

/**
 * Check the return values from the CurrentUser query to see whether the user is authenticated.
 *
 * The user is only authenticated if there is data in the currentUser field.
 */
export const computeAuthenticationStatus = (
  data: CurrentUserQuery | undefined,
  loading: boolean,
  error: ApolloError | undefined,
) => {
  if (loading) {
    return AuthenticationStatus.LOADING;
  }

  if (error) {
    return AuthenticationStatus.LOGGED_OUT;
  }

  if (data?.currentUser) {
    return AuthenticationStatus.LOGGED_IN;
  } else {
    return AuthenticationStatus.LOGGED_OUT;
  }
};
